module.exports = __webpack_public_path__ + "img/soul-intro.f0549123.png";